import PropTypes from 'prop-types';
import React, { memo } from 'react';

import RefreshIcon from 'assets/RefreshIcon';
import Tooltip from 'components/v2/Tooltip';

import { StyledRefreshButton } from './RefreshButton.styles';

const RefreshButton = ({ onClick, disabled, isLoading }) => (
  <Tooltip title="Refresh" placement="top" arrow>
    <span>
      <StyledRefreshButton
        onClick={onClick}
        size="small"
        disabled={disabled || isLoading}
        $isLoading={isLoading}
      >
        <RefreshIcon />
      </StyledRefreshButton>
    </span>
  </Tooltip>
);

RefreshButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default memo(RefreshButton);
